import {
  ContentServiceClient,
} from "@data/content-service-client";

import { wrapResponse } from "./wrapResponse";

async function getStoriesByNiHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as {
    niCode: string;
    minAge?: string;
    maxAge?: string;
    types?: string;
  };

  const { niCode, minAge, maxAge } = params;

  const types = req.query.types?.split(",") || [];

  const contentServiceClient = ContentServiceClient.init({
    host: process.env.CONTENT_SERVICE_URL,
    username: process.env.CONTENT_SERVICE_USERNAME,
    password: process.env.CONTENT_SERVICE_PASSWORD,
  });

  const contentServiceResponse =
    await contentServiceClient.postV1StoriesSearchBy({
      and: [
        { niCode },
        { storyPublishedAt: { lte: minAge } },
        { storyPublishedAt: { gte: maxAge } },
        {
          or: types.map((type) => ({
            type,
          })),
        },
      ],
    });

  return res.status(200).json(contentServiceResponse.collection.items);
}

export default getStoriesByNiHandler;
